import { useEffect, useState } from 'react'
import { ArrowDown, FileText, Mail } from 'lucide-react'

import { SITE } from '../data/site'
import { usePrefersReducedMotion } from '../hooks/usePrefersReducedMotion'
import styles from './Hero.module.css'

const ROTATE_MS = 2600

const FACTS = [
  { label: 'Leading teams since', value: '2016' },
  { label: 'Currently', value: 'AWS IoT' },
  { label: 'Based in', value: 'Arkansas' },
]

export function Hero() {
  const reducedMotion = usePrefersReducedMotion()
  const [index, setIndex] = useState(0)

  useEffect(() => {
    if (reducedMotion) return
    const timer = window.setInterval(() => {
      setIndex((current) => (current + 1) % SITE.roles.length)
    }, ROTATE_MS)
    return () => window.clearInterval(timer)
  }, [reducedMotion])

  return (
    <section className={styles.hero} aria-labelledby="hero-heading">
      <div className={styles.glow} aria-hidden="true" />

      <div className={`container ${styles.inner}`}>
        <p className={`eyebrow ${styles.eyebrow}`}>
          <span className={styles.pulse} aria-hidden="true" />
          {SITE.role} · {SITE.employer}
        </p>

        <h1 id="hero-heading" className={styles.name}>
          {SITE.name}
        </h1>

        <p className={styles.roles}>
          <span className={styles.rolesPrefix}>I&rsquo;m a&nbsp;</span>
          {/*
            The rotator is decorative. Screen readers get the full, stable list
            below instead of a string that changes every few seconds.
          */}
          <span className={styles.rotator} aria-hidden="true">
            {SITE.roles.map((role, i) => (
              <span
                key={role}
                className={styles.role}
                data-visible={reducedMotion ? i === 0 : i === index}
              >
                {role}
              </span>
            ))}
          </span>
          <span className="visually-hidden">{SITE.roles.join(', ')}.</span>
        </p>

        <p className={styles.tagline}>{SITE.tagline}</p>

        <div className={styles.ctas}>
          <a className={styles.primary} href="#contact">
            <Mail size={17} aria-hidden="true" />
            Get in touch
          </a>
          <a
            className={styles.secondary}
            href={SITE.resumeHref}
            target="_blank"
            rel="noopener"
          >
            <FileText size={17} aria-hidden="true" />
            Résumé
            <span className="visually-hidden">(PDF, opens in a new tab)</span>
          </a>
        </div>

        <dl className={styles.facts}>
          {FACTS.map((fact) => (
            <div key={fact.label} className={styles.fact}>
              <dt>{fact.label}</dt>
              <dd>{fact.value}</dd>
            </div>
          ))}
        </dl>

        <a className={styles.scrollCue} href="#about" data-no-print>
          <ArrowDown size={16} aria-hidden="true" />
          <span>Read on</span>
        </a>
      </div>
    </section>
  )
}
